import axiosInstance from '../helpers/axios';
import { handleError, handleSuccess } from '../helpers/utils';
import { getToken } from './auth';
import { generateExternalTollingExportReport } from './pdf';

// Get external tolling request by key
export const getExternalTollingRequestsByKey = async (key) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/order/external-tolling-request/?key=${key}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get external tolling requests' info
export const getExternalTollingRequestInfo = async (id) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/order/external-tolling-request/${id}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Register external tolling request
export const registerExternalTollingRequest = async (data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/order/external-tolling-request/create/',
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Update external tolling request
export const updateExternalTollingRequest = async (id, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'put',
		url: `/api/order/external-tolling-request/update/${id}`,
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Delete external tolling request
export const deleteExternalTollingRequest = async (id, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'delete',
		url: `/api/order/external-tolling-request/${id}`,
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Handle generate ETR PDF
export const handleGeneratEtrPDF = (payloadPDF) => {
	generateExternalTollingExportReport(payloadPDF)
		.then(() => {
			handleSuccess('Reporte generado');
		})
		.catch((error) => {
			handleError(
				error,
				'Ocurrió un error al intentar generar el reporte'
			);
		});
};
